import { Chip } from "@plum-xoxo/admin-dsm";
import styled from "styled-components";

const StyledChip = styled(Chip).attrs()`
  border: 1px solid ${(props) => props.theme.palette.light.c300};
  padding: 8px 12px;
  .eui-chip-label {
    padding: 0;
    margin-left: 5px;
  }
  background-color: ${(props) =>
    props.disabled ? props.theme.palette.light.c100 : ""};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "")};
  pointer-events: ${(props) => (props.disabled ? "all !important" : "")};
`;

export default StyledChip;
